import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Mandatory({ size, ...props }) {
  return (
    <SvgIconComponent
      height="13"
      width="13"
      fill="none"
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M4.1936 8.96687L5.44381 7.10554L3.49854 6.49444L3.94356 5.1052L5.91593 5.91133L5.80483 3.79999H7.49921L7.3881 5.91133L9.36048 5.1052L9.77754 6.49444L7.86023 7.10554L9.11044 8.96687L7.88819 9.79999L6.66606 7.82767L5.41585 9.79999L4.1936 8.96687Z"
        fill="#A0A0AA"
      />
    </SvgIconComponent>
  )
}

export function TrailingPassword({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 24.2857C4 24.2857 11.2727 10 24 10C36.7273 10 44 24.2857 44 24.2857C44 24.2857 36.7273 38.5714 24 38.5714C11.2727 38.5714 4 24.2857 4 24.2857Z"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7618 24.2858C28.7618 26.9158 26.6299 29.0477 23.9999 29.0477C21.37 29.0477 19.238 26.9158 19.238 24.2858C19.238 21.6559 21.37 19.5239 23.9999 19.5239C26.6299 19.5239 28.7618 21.6559 28.7618 24.2858Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TrailingPasswordHide({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M9.75071 10L38.3221 37.6952M36.4174 32.2857C39.1012 29.8657 41.3609 27.0137 43.1031 23.8476C43.1031 23.8476 36.1697 10.2476 24.0554 10.2476C21.2144 10.266 18.4239 10.9997 15.9412 12.381M11.6935 15.4095C9.00974 17.8294 6.74993 20.6815 5.00781 23.8476C5.00781 23.8476 11.9411 37.4476 24.0554 37.4476C26.8964 37.4293 29.6871 36.6955 32.1697 35.3142M19.5983 23.1048C19.5796 23.352 19.5796 23.6003 19.5983 23.8476C19.5983 25.0499 20.0759 26.203 20.9261 27.0532C21.7762 27.9033 22.9293 28.3809 24.1316 28.3809C24.4262 28.3786 24.7197 28.3467 25.0078 28.2857M28.5888 24.5905C28.6075 24.3432 28.6075 24.0949 28.5888 23.8476C28.5888 22.6453 28.1112 21.4922 27.261 20.642C26.4108 19.7919 25.2577 19.3143 24.0554 19.3143C23.7609 19.3166 23.4674 19.3485 23.1793 19.4095"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TrailingInfo({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="14"
      width="15"
      fill="none"
      viewBox="0 0 15 14"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M13.4993 7.09995C13.4993 10.4137 10.813 13.1 7.49931 13.1C4.1856 13.1 1.49931 10.4137 1.49931 7.09996C1.49931 3.78625 4.1856 1.09995 7.49931 1.09995C10.813 1.09995 13.4993 3.78625 13.4993 7.09995Z"
        stroke={stroke ?? '#4D8CE8'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.49951 7.10004L7.49951 10.1"
        stroke={stroke ?? '#4D8CE8'}
        strokeLinecap="round"
        strokeWidth="1.46667"
      />
      <path
        d="M7.50334 4.10004C7.61218 4.10004 7.71451 4.12191 7.81027 4.16562C7.91042 4.20494 7.99531 4.2618 8.06497 4.33611C8.139 4.40605 8.19559 4.49129 8.23476 4.59185C8.27832 4.68803 8.30007 4.79074 8.30007 4.90004C8.30007 5.00497 8.27832 5.10551 8.23476 5.20169C8.19559 5.29787 8.139 5.3831 8.06497 5.45743C7.99531 5.53174 7.91042 5.59077 7.81027 5.63448C7.71451 5.67819 7.61218 5.70004 7.50334 5.70004C7.39885 5.70004 7.29654 5.67819 7.1964 5.63448C7.10062 5.59513 7.01572 5.54047 6.94171 5.47053C6.86769 5.39621 6.80892 5.31098 6.76538 5.2148C6.72184 5.11426 6.70007 5.00933 6.70007 4.90004C6.70007 4.79074 6.72184 4.68803 6.76538 4.59185C6.80892 4.49128 6.86551 4.40605 6.93517 4.33611C7.00919 4.2618 7.09409 4.20494 7.18987 4.16562C7.29001 4.12191 7.3945 4.10004 7.50334 4.10004Z"
        fill={stroke ?? '#4D8CE8'}
      />
    </SvgIconComponent>
  )
}

export function TrailingSuccess({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="14"
      width="14"
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M4.03271 7.29915L5.83395 9.13574L9.36605 5.6333"
        stroke={stroke ?? '#91D656'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M12.6994 6.96665C12.6994 10.2804 10.0131 12.9667 6.69938 12.9667C3.38567 12.9667 0.699382 10.2804 0.699382 6.96665C0.699382 3.65295 3.38567 0.966654 6.69938 0.966654C10.0131 0.966654 12.6994 3.65295 12.6994 6.96665Z"
        stroke={stroke ?? '#91D656'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}
export function TrailingDanger({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="14"
      width="14"
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M1.30074 7.10024C1.30074 3.78653 3.98703 1.10024 7.30074 1.10024C10.6144 1.10024 13.3007 3.78653 13.3007 7.10024C13.3007 10.4139 10.6144 13.1002 7.30074 13.1002C3.98703 13.1002 1.30074 10.4139 1.30074 7.10024Z"
        stroke={stroke ?? '#D64949'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.29944 4.43359V7.10026"
        stroke={stroke ?? '#D64949'}
        strokeLinecap="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.30327 8.43359C7.41211 8.43359 7.51443 8.45546 7.6102 8.49918C7.71035 8.5385 7.79523 8.59535 7.86489 8.66966C7.93892 8.73961 7.99552 8.82484 8.03469 8.92541C8.07824 9.02159 8.1 9.1243 8.1 9.23359C8.1 9.33852 8.07824 9.43907 8.03469 9.53525C7.99552 9.63142 7.93892 9.71666 7.86489 9.79099C7.79523 9.8653 7.71035 9.92432 7.6102 9.96804C7.51443 10.0118 7.41211 10.0336 7.30327 10.0336C7.19878 10.0336 7.09646 10.0118 6.99633 9.96804C6.90054 9.92869 6.81565 9.87403 6.74163 9.80408C6.66762 9.72977 6.60884 9.64454 6.5653 9.54836C6.52177 9.44782 6.5 9.34289 6.5 9.23359C6.5 9.1243 6.52177 9.02159 6.5653 8.92541C6.60884 8.82484 6.66544 8.73961 6.7351 8.66966C6.80911 8.59535 6.89401 8.5385 6.9898 8.49918C7.08993 8.45546 7.19442 8.43359 7.30327 8.43359Z"
        fill={stroke ?? '#D64949'}
      />
    </SvgIconComponent>
  )
}
export function TrailingDropDown({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
      stroke={stroke ?? '#141A21'}
    >
      <path
        d="M5.33398 6.68244L7.99442 9.43634L10.6673 6.6665"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function TrailingDropUp({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
      stroke={stroke ?? '#141A21'}
    >
      <path
        d="M5.33398 9.42035L7.99442 6.66645L10.6673 9.43628"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function TrailingInactive({ size, ...props }) {
  return (
    <SvgIconComponent
      height="15"
      width="14"
      fill="none"
      viewBox="0 0 14 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M1.30062 7.46694C1.30062 4.15323 3.98691 1.46694 7.30062 1.46694C10.6143 1.46694 13.3006 4.15323 13.3006 7.46694C13.3006 10.7806 10.6143 13.4669 7.30062 13.4669C3.98691 13.4669 1.30062 10.7806 1.30062 7.46694Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.29932 4.80029V7.46696"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.30314 8.80029C7.41199 8.80029 7.51431 8.82216 7.61007 8.86587C7.71023 8.9052 7.79511 8.96205 7.86477 9.03636C7.9388 9.10631 7.9954 9.19154 8.03456 9.29211C8.07812 9.38828 8.09988 9.491 8.09988 9.60029C8.09988 9.70522 8.07812 9.80577 8.03456 9.90194C7.9954 9.99812 7.9388 10.0834 7.86477 10.1577C7.79511 10.232 7.71023 10.291 7.61007 10.3347C7.51431 10.3784 7.41199 10.4003 7.30314 10.4003C7.19865 10.4003 7.09634 10.3784 6.9962 10.3347C6.90042 10.2954 6.81552 10.2407 6.74151 10.1708C6.6675 10.0965 6.60872 10.0112 6.56518 9.91506C6.52165 9.81452 6.49988 9.70959 6.49988 9.60029C6.49988 9.491 6.52165 9.38828 6.56518 9.29211C6.60872 9.19154 6.66532 9.10631 6.73498 9.03636C6.80899 8.96205 6.89389 8.9052 6.98967 8.86587C7.08981 8.82216 7.1943 8.80029 7.30314 8.80029Z"
        fill="#A0A0AA"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Mandatory.propTypes = iconPropTypes
TrailingPassword.propTypes = iconPropTypes
TrailingPasswordHide.propTypes = iconPropTypes
TrailingInfo.propTypes = iconPropTypes
TrailingSuccess.propTypes = iconPropTypes
TrailingDanger.propTypes = iconPropTypes
TrailingDropDown.propTypes = iconPropTypes
TrailingDropUp.propTypes = iconPropTypes
TrailingInactive.propTypes = iconPropTypes

const iconsTextInput = {
  Mandatory,
  TrailingPassword,
  TrailingPasswordHide,
  TrailingInfo,
  TrailingSuccess,
  TrailingDanger,
  TrailingDropDown,
  TrailingDropUp,
  TrailingInactive
}

export default iconsTextInput
